const Input = {
  defaultProps: {
    variant: 'filled',
  }

};

export default Input;
